<template>
  <page-chrome color-class="is-example">
    <h1 class="title">{{ productName }}</h1>
    <div class="content-container">
      <b-field label="Search">
        <b-input v-model.trim="query" rounded type="search" placeholder="Enter search terms here" @keyup.native="search" autofocus autocapitalize="off" enterkeyhint="Search" />
      </b-field>
    </div>
  </page-chrome>
</template>

<script>
import { productName } from '../services/branding'
export default {
  computed: {
    productName () { return productName },
  },
  data () {
    return {
      query: ''
    }
  },
  methods: {
    search (e) {
      if (e.keyCode !== 13) return
      this.$store.commit('filters/resetWith', { query: this.query, orderBy: 'relevance', dateScope: 'last7Days' })
      this.$router.push({ name: 'search' })
    }
  }
}
</script>